

export default (filesArray, sortQuery) => {
   // const commonReducer = useSelector((state) => state.root.commonReducer);
    // console.log(filesArray)
   // const filesArray = commonReducer.filtered_events;
   if(sortQuery == null ){
    sortQuery = 'view_all'
   }
    let sortedFiles=[]

        if (sortQuery == 'date_added'){
      const sorted = [...filesArray].sort((a, b) => a.created_at > b.created_at ? -1 : 1, );
   sortedFiles = sorted
    }
   
    if (sortQuery == 'start_dates'){
      const sorted = [...filesArray].sort((a, b) =>
    a.start_date > b.start_date ? -1 : 1,
   );
   sortedFiles = sorted
    }


if (sortQuery == 'end_dates'){
    const sorted = [...filesArray].sort((a, b) =>
  a.editor_start_date > b.editor_start_date ? -1 : 1,
 );
 sortedFiles = sorted
  }
    
if(sortQuery == 'a_z'){
  const sorted = [...filesArray].sort((a, b) =>
  a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
 );
 sortedFiles = sorted

  }

   if (sortQuery == 'view_all'){
      const sorted = [...filesArray]
   sortedFiles = sorted
    }

  

    if (sortQuery == 'completed'){
      const sorted = filesArray?.filter(file => file.status_type_order == 5 );
      // console.log(sorted)
   sortedFiles = sorted
    }

        if (sortQuery == 'pre_production'){
      const sorted = filesArray?.filter(file => file.status_type_order == 1 );
      // console.log(sorted)
   sortedFiles = sorted
    }

        if (sortQuery == 'production'){
      const sorted = filesArray?.filter(file => file.status_type_order == 2 );
      // console.log(sorted)
   sortedFiles = sorted
    }

        if (sortQuery == 'post_production'){
      const sorted = filesArray?.filter(file => file.status_type_order == 3 );
      // console.log(sorted)
   sortedFiles = sorted
    }

        if (sortQuery == 'revision'){
      const sorted = filesArray?.filter(file => file.status_type_order == 4 );
      // console.log(sorted)
   sortedFiles = sorted
    }
 

            if (sortQuery == 'active'){
      const sorted = filesArray?.filter(file => file.status_type_order >= 1 && file.status_type_order < 4);
      // console.log(sorted)
   sortedFiles = sorted
    }

    if(sortQuery == "" || sortQuery == null || sortQuery == 'view_all'){
      sortedFiles = [...filesArray]
    }

  
    return [sortedFiles];
  };


